import React, {useState,useEffect} from "react"; 
import {useStyles} from "./styles"; 
import Container from '@material-ui/core/Container'; 
import Typography from "@material-ui/core/Typography"; 
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import { Link as RouterLink } from 'react-router-dom';
import Scrollbars from "react-custom-scrollbars";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import AttachmentIcon from '@material-ui/icons/Attachment';
// Card add
import Card from '@mui/material/Card'; 
import Paper from '@mui/material/Paper';
import * as actions from "../../../store/actions";
import { Loader, NoData } from '../../../components'
import {connect} from "react-redux"; 
import "../scss/general.scss";
import "../scss/home.scss";
import "../scss/projectdetail.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick"; 

var projectDetailSlider = {
    dots: true,
    infinite: true,
    speed: 500,
    responsive: [
        {
            breakpoint: 0, 
            settings: {
                slidesToShow: 1, 
                slidesToScroll: 1,
                centerPadding: '40px',
                centerMode: true,
                dots: false,
            },
        },
        {
            breakpoint: 414, 
            settings: {
                slidesToShow: 1, 
                slidesToScroll: 1,
                centerPadding: '20px',
                centerMode: true,
                dots: false,
            },
        },
        {
            breakpoint: 480, 
            settings: {
                slidesToShow: 1, 
                slidesToScroll: 1,
                centerPadding: '30px',
                centerMode: true,
                dots: false,
            },
        },
        {
            breakpoint: 600, 
            settings: {
                slidesToShow: 2, 
                slidesToScroll: 2,
                centerPadding: '20px',
                centerMode: true,
                dots: false,
            },
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 2, 
                slidesToScroll: 2,
                dots: true,
            },
        },
        {
            breakpoint: 992, 
            settings: {
                slidesToShow: 2, 
                slidesToScroll: 2,
                dots: true,
            },
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true,
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true,
            }
        },
        {
            breakpoint: 1280, 
            settings: {
                slidesToShow: 3, 
                slidesToScroll: 3,
                dots: true,
            },
        },
        {
            breakpoint: 1600, 
            settings: {
                slidesToShow: 3, 
                slidesToScroll: 3,
                dots: true,
            },
        },
        {
            breakpoint: 2500, 
            settings: {
                slidesToShow: 3, 
                slidesToScroll: 3,
                dots: true,
            },
        },
    ]
};

function ProjectDetails(props) {      
    const classes = useStyles(); 
    const [gallery, setGallery] = useState([]);
    const [render, setRender] = useState(0);

    let url = props?.location?.pathname.split("/");
    let id = url[url?.length-1];

    useEffect(() => {
        if(id) {
            fetchProjectDetail(id);
        }
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [props.location.pathname,]);

    useEffect(() => {
        if(props?.success){
            // console.log("props?.projectDetail?.projectGall?.gallery",props?.projectDetail?.projectGall?.gallery)
            setGallery(props?.projectDetail?.projectGall?.gallery)
            setRender(render+1)
        }
    }, [props?.success]);

    useEffect(() => {
        if(props?.success){
            console.log("gallery is called",gallery)
        }
    }, [render]);
   
    const projectDetails = (item) => {
        props.history.push({pathname:`/project-details/${item._id}`});
    }

    // console.log('projectDetail========== ', props?.projectDetail);
    const fetchProjectDetail = (id) => {
        props.getProjectDetailStart({id});
    }
    
    return (
        <div>
            <Container fixed>
                <Breadcrumbs className="bredcum" aria-label="breadcrumb">
                    <RouterLink to={`/projects/${props?.projectDetail?.data?.category?.parent_category_id}`}>
                        Projects
                    </RouterLink>
                    <RouterLink                    
                        to={`/projects/${props?.projectDetail?.data?.category?.parent_category_id}`}
                    >
                        {(props?.projectDetail?.data?.category?.parent_category_id == '63c2ac4e5f1f55cb03a15d4f') ? "Hydropower" : (props?.projectDetail?.data?.category?.parent_category_id == '63c2ac775f1f55cb03a15d59') ? "Water Sector" : "--"}
                    </RouterLink>
                    <RouterLink
                        to={`/projects/${props?.projectDetail?.data?.category?.parent_category_id}`}
                    >
                        {props?.projectDetail?.data ? props?.projectDetail?.data?.category?.description : '--'}
                    </RouterLink>
                    <Typography className="bredcum-active">{props?.projectDetail?.data ? props?.projectDetail?.data?.title : '--'}</Typography>
                </Breadcrumbs>
            </Container>
            <Container fixed className="project-detail-container">
            {
                (props?.loading) ? <Loader />
                :
                (props?.projectDetail && props?.projectDetail?.data) ?
                    <Grid container spacing={4} >
                        <Grid item xs={12} lg={8}>
                            <Card className={`${classes.projectlist} project-main-card`}>
                                <img loading="lazy" className="project-main-detail-img object-fit img-full img-responsive" src={props?.projectDetail?.data?.image?.completedUrl}></img>
                                <div>
                                    <span dangerouslySetInnerHTML={{__html: props?.projectDetail?.data?.post_data}} />
                                </div>
                                
                            </Card>
                            {(props?.projectDetail?.files) &&
                                <div className="files-chip-btn">
                                    {props?.projectDetail?.files.map((file) => (
                                        <Chip className="chip-style" icon={<AttachmentIcon />} label={file?.title} onClick={() => window.open(file?.file?.completedUrl, '_blank')} />
                                    ))}
                                </div>
                            }
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Paper elevation={0} className="project-list-box">
                                <Typography
                                    component="h1"
                                    variant="body2"
                                    className="project-multileheading-h1"
                                >
                                    {(props?.projectDetail?.data?.category?.parent_category_id == '63c2ac4e5f1f55cb03a15d4f') ? "More Hydropower Dams" : "More Water Sector Dams"}
                                </Typography>
                                <Scrollbars autoHide style={{height:380}}>
                                    <List sx={{ width: '100%'}} className="project-paddingsm-bottom">
                                        { (props?.projectDetail?.moreDams || []).map((item)=> {
                                            return(
                                                <ListItem alignItems="flex-start">
                                                    <ListItemAvatar className="project-mr-right">
                                                        <RouterLink to={`/project-details/${item._id}`}>
                                                            <img className="project-imagesm" src={item?.thumbnail?.completedUrl}></img>
                                                        </RouterLink>
                                                    </ListItemAvatar>
                                                    <div className="project-content-main">
                                                        <div>
                                                            <Typography
                                                                component="h3"
                                                                variant="body2"
                                                                className="project-multileheadingsm-h3 cursor-button ellipses-line-text"
                                                                onClick={() => projectDetails(item)}
                                                            >
                                                                {item?.title}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </ListItem>
                                            )
                                        })} 
                                    </List>
                                </Scrollbars>
                            </Paper>
                        </Grid>
                    </Grid>
                    
                :
                    <NoData text={"No data found"} />
            }
            </Container>
            <Container fixed className="padd-mb-off project-carosal-contaner">
                <Slider className='bluedots' loop margin={10} {...projectDetailSlider}>
                    {props?.projectDetail?.projectGall?.gallery?.map(item =>(
                        <div class='item'>
                            <img
                                loading="lazy"
                                className="horizontal-box-image img-full object-fit cursor-button"
                                src={item?.image?.completedUrl}
                            />
                        </div> 
                    ))}
                </Slider>
            </Container>
        </div>
    );
}

//what is needed at start
const mapStateToProps = ({cmsReducer}) => {
    const { projectDetail,error, success, loading } = cmsReducer;
    return { projectDetail,error,success,loading};
};

//which actions our function can dispatch
const mapDispatchToProps = (dispatch) => {
    return {
        getProjectDetailStart: (data) => dispatch(actions.getProjectDetail(data)),
        cmsMessageHandler: () => dispatch(actions.cmsMessageHandler()),  
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetails);